import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { hash } from '@/utils/cache';
import { SelectorTooltip } from '@/features/editor/widgets/changelog/components';

interface ClampedTextProps {
  text: string;
  lines?: number;
  shortLimit?: number;
  shouldMeasure?: boolean;
}

interface TextWrapperProps {
  lines?: number;
}

export function ClampedText({
  text,
  lines,
  shortLimit = 30,
  shouldMeasure,
}: ClampedTextProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const [isClamped, setIsClamped] = useState(false);

  const id = useMemo(() => `clamped-${hash(text)}`, [text]);

  const mightBeClamped = lines > 0 && text.length >= shortLimit;

  useEffect(() => {
    if (!shouldMeasure || !mightBeClamped) return;
    const el = ref.current;
    if (!el) return;
    setIsClamped(el.scrollHeight - el.clientHeight > 10);
  }, [shouldMeasure]);

  return (
    <>
      <TextWrapper
        ref={ref}
        lines={lines}
        data-tip
        data-for={isClamped ? id : undefined}
      >
        {text}
      </TextWrapper>
      {isClamped && <SelectorTooltip id={id} selector={text} image="" />}
    </>
  );
}

const TextWrapper = styled.span<TextWrapperProps>`
  ${({ lines }) =>
    lines > 0 &&
    `
    display: -webkit-box;
    -webkit-line-clamp: ${lines};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    line-break: anywhere;
  `}
`;
